module.exports = __webpack_public_path__ + "img/pic14.80365e05.jpg";